import siteIds from '../../constants/siteIds';

export default function (subtotal, siteId, totalLeft) {
	let cartLimit;
	let limit;

	if (totalLeft >= 0) {
		cartLimit = totalLeft;
		if (subtotal === 0) {
			limit = cartLimit / 20;
		} else {
			limit = (cartLimit - subtotal) / 20;
		}
	} else {
		cartLimit = siteId === siteIds.giftCardConnection ? 60 : 160;
		if (subtotal === 0 && siteId !== siteIds.giftCardConnection) {
			limit = 8;
		} else if (subtotal === 0 && siteId === siteIds.giftCardConnection) {
			limit = 3;
		} else {
			limit = (cartLimit - subtotal) / 20;
		}
	}

	return limit;
}
